/**
 * Search param asking the Channels settings page to coach the actor toward a
 * subset of their channels. Set by whoever links there, read by the page — a
 * direct visit to Channels stays uncoached.
 */
export const CHANNEL_HIGHLIGHT_PARAM = 'highlight'

/** Highlights Instagram channels connected through Instagram login. */
export const CHANNEL_HIGHLIGHT_INSTAGRAM_LOGIN = 'instagram-login'

export const instagramLoginChannelsUrl = `/settings/channels?${CHANNEL_HIGHLIGHT_PARAM}=${CHANNEL_HIGHLIGHT_INSTAGRAM_LOGIN}`
